import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { NoDocumentsSvg } from './NoDocumentsSvg'

type Props = {
  isIconDisplayed: boolean
}

function NoDocuments({ isIconDisplayed }: Props) {
  if (!isIconDisplayed) {
    return (
      <div className="w-full flex flex-col justify-center">
        Nenašli sa žiadne dokumenty.
      </div>
    )
  }

  return (
    <div className="w-full flex flex-col items-center justify-center mt-[40px] lg:mt-[80px]">
      <NoDocumentsSvg className="h-auto" />
      <HeadingThree className="text-center text-2xl mt-[40px]">
        Zatiaľ nemáte žiadne dokumenty
      </HeadingThree>
    </div>
  )
}

export { NoDocuments }
